<style>

.popup-content{
    height: auto;
    width: 500px;
}

.popup-left{
    width: 50%;
    display: inline-block;
}

.popup-right{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    margin-top: 1%;
}

.popup-picture{
    width: 70%;
    border-radius: 5%;
}
.popup-text-post{
    font-size: 2em;
    font-weight: bold;
    text-align: justify;
}

.popup-text-description{
    margin-top: 6%;
    text-align: justify;
}

/*-------------------------------------
---------------------------------------
            MOBILE VIEW
---------------------------------------
---------------------------------------*/

@media only screen and (max-width: 600px){
    .popup-content{
        height: auto;
        width: 250px;
    }

    .popup-left{
        width: 100%;
        display: inline-block;
    }

    .popup-right{
        width: 100%;
        display: inline-block;
        vertical-align: top;
        margin-top: 1%;
    }
 
    .popup-picture{
        width: 100%;
        border-radius: 5%;
    }
}

</style>

<div class="popup-content">
    <div class="popup-left">
        <img class ="popup-picture" src="../../assets/images/t3f_icon_deg.png">
    </div>
    <div class="popup-right">
        <span class="popup-text-post">Voluntario evento tecnológico T3chfest</span>
        <br>
        <p class="popup-text-description">Voluntario en el T3chfest, la feria de informática y nuevas tecnologías en la Universidad Carlos III de Madrid</p>
    </div>

    
    
</div>